// BREAKPOINTS
export const BREAKPOINT_MOBILE = 467;
export const BREAKPOINT_TABLET = 768;
export const BREAKPOINT_LARGE_TABLET = 992;
export const BREAKPOINT_SMALL_DESKTOP = 1260;

// SOCIAL NETWORKS
export const INSTAGRAM = 'https://www.instagram.com/convelio/';
export const LINKEDIN = 'https://www.linkedin.com/company/convelio/about/';
export const FACEBOOK = 'https://www.facebook.com/Convelio-756697587853828/';
export const TWITTER = 'https://twitter.com/convelio';

// SCROLL
export const PIXELS_FOR_NAVBAR_SCROLL_STATE = 100;
export const PIXELS_TO_SCROLL_TO_SHOW_SCROLL_TO_TOP_BUTTON = 4000;

//TIMEOUT
export const PUSH_PAGE_VIEW_EVENT_TIMEOUT = 1000;
export const PUSH_AXEPTIO_TIMEOUT = 1000;
export const SCROLL_TIMEOUT = 1000;
export const DEBOUNCE_TIME = 800;
export const SCROLL_TO_NODE_TIME = 400;

//IP ADDRESSES (TESTING)
export const FRANCE_IP = '93.19.100.206';
export const ITALY_IP = '81.120.19.160';
export const USA_IP = '63.70.164.200';
export const SPAIN_IP = '83.36.251.101';

//CARDS
export const WIDTH_SLIDING_CARD = 520;
export const MARGIN_RIGHT_SLIDING_CARD = 24;

//FILTERS
export const ALL_FILTERS = {
  id: 'ALL_FILTERS_ID',
  title: 'All'
};

//DEVICES
export const MOBILE = 'mobile';
export const TABLET = 'tablet';
export const TABLET_LARGE = 'tablet large';
export const DESKTOP_SMALL = 'desktop small';
export const DESKTOP = 'desktop';

//DATALAYER
export const PAGE_VIEW = 'pageView';
export const GA = 'ga_event';
export const EMAIL_PREFERENCES_PAGE_TITLE = 'Email preferences page';
export const EMAIL_PREFERENCES_CATEGORY = 'email preferences';
export const EMAIL_PREFERENCES_SAVED = 'email preferences saved';
export const OPTING_OUT_FEEDBACK = 'opting out feedback';
export const AUTHORS_PAGE_TITLE = 'Authors page';
export const AUTHORS_CATEGORY = 'author';
export const ARTICLES_PAGE_TITLE = 'Articles page';
export const ARTICLES_CATEGORY = 'article';
export const BLOG_CATEGORY = 'blog';
export const UNDEFINED = 'undefined';

//EMAIL PREFERENCES
export const MANY_EMAILS = 'too many emails';
export const NOT_INTERESTED = 'shipment emails only';
export const OTHER = 'other';
export const ALL_OPTED_IN = 'all opted in';
export const ALL_OPTED_OUT = 'opted out';
export const PARTLY_OPTED_IN = 'partly opted in';
export const SWITCH_PREFERENCES = 'SWITCH_PREFERENCES';
export const SWITCH_PREFERENCE = 'SWITCH_PREFERENCE';
export const SET_PREFERENCES = 'SET_PREFERENCES';
export const SET_STEP = 'SET_STEP';
export const UPDATE_OPT_IN_STATUS = 'UPDATE_OPT_IN_STATUS';

//NAVBAR
export const SWITCH_NAVBAR_STATE = 'SWITCH_NAVBAR_STATE';
export const SET_NAVBAR_STATE_PROP = 'SET_NAVBAR_STATE_PROP';

//COLORS
export const SLATE_GREY_10 = '#fafafa';
export const SLATE_GREY_40 = 'rgba(210, 211, 215, 1)';
export const SLATE_GREY_60 = '#9B9EAA';
export const SLATE_GREY_80 = '#686e80';
export const PRIMARY = '#174ef3';
export const PRIMARY_80 = 'rgba(100, 137, 247, 1)';

//API
export const SUCCEED = 'succeed';

//DATALAYER
export const GEOLOC_ACTION = 'clicked search cta';
export const GEOLOC_CATEGORY = 'geo module';
